export const SUPADEMO_GUIDED_TOUR_ID = "cm3rvqtnl0ip25a3tq3pe6b1l";
export const SUPADEMO_SETTINGS_DEMO_ID = "cm3szpaj50wgu5a3to8bvqq22";
export const SUPADEMO_APPOINTMENT_FORM_DEMO_ID = "cm3t96h9q10xx5a3tgzotqftu";
